import { FeatureFlag } from '@sonar-software/sonar-core';
import { FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { Navigate } from 'react-router-dom';
import { useFeatureFlag } from '@hooks';

import React, { PropsWithChildren } from 'react';

export interface FeatureRouteWrapperProps {
	feature: FeatureFlag;
	fallback?: React.ReactElement;
}

export const FeatureRouteWrapper: React.FC<PropsWithChildren<FeatureRouteWrapperProps>> = ({ children, feature, fallback }) => {
	const isFeatureEnabled = useFeatureFlag(feature);

	return isFeatureEnabled ? (children as React.ReactElement) : fallback ?? <Navigate to={ FULL_ROUTES.DASHBOARD } />;
};
